<template>
  <Modal v-model="uploadIossModal" :title="uploadIossTitle" width="550"
    :transfer="false" :mask-closable="false" @on-visible-change="uploadIossChange">
    <Form ref="uploadIossForm" :model="uploadIossForm" :rules="ruleValidate" :label-width="labelWidth" @submit.native.prevent>
      <Row style="width: 90%">
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <Form-item prop="iossType" :label-width="35">
            <RadioGroup v-model="uploadIossForm.iossType" @on-change="selectChange">
              <Radio style="margin-right: 30px;" v-for="item in iossTypeList" :label="item.value" :key="item.value">{{ item.name }}</Radio>
            </RadioGroup>
          </Form-item>
        </Col>
        <!--使用已有IOSS-->
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol" v-if="uploadIossForm.iossType === 1">
          <Form-item :label="$t('key1005999')" prop="ymsIossId">
            <div class="flex align-items-center">
              <Select v-model="uploadIossForm.ymsIossId" filterable transfer :placeholder="$t('key1000101')"
                style="width: 250px;" @on-open-change="openIossChange">
                <Option v-for="item in iossList" :value="item.code" :label="item.iossName">
                  <span v-html="item.title"></span>
                </Option>
              </Select>
              <span class="ml5 cursor distributorThemeColor text-decoration" @click="goIossConfig">{{ $t('key1006002') }}</span>
            </div>
          </Form-item>
        </Col>
        <!--物流代缴-->
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol" v-if="uploadIossForm.iossType === 2 && iossLogisticCostTalg">
          <div class="flex flex-direction ml38">
            <p class="mb7">{{ $t('key1006000') + configCharacters() + $t('key1006001')}}</p>
            <p class="mb7">{{ $t('key1001579') + shippingMethodName }}</p>
            <p class="flex align-items-center">
              <span>{{ $t('key1006003') }}</span>
              <span class="distributorThemeColor ml3">{{ iossLogisticCost + ' ' + currencyState }}</span>
            </p>
          </div>
        </Col>
        <!--手动录入-->
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol" v-if="uploadIossForm.iossType === 3">
          <Form-item :label="$t('key1005521')" prop="iossNo">
            <Input clearable v-model.trim="uploadIossForm.iossNo" style="width: 250px;"/>
          </Form-item>
        </Col>
      </Row>
    </Form>
    <template #footer>
      <Button @click="uploadIossModal = false">{{ $t('key1000112') }}</Button>
      <Button type="primary" @click="uploadIossBtn">{{ $t('key1000543') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import api from '@/api/';
import Mixin from "@/components/mixin/common_mixin";
import {
  isJSON, amountHandel, pageJump, getQueryCarrierShippingName,
  getYunLogisticsAll, getDataSetBatchList, getEnumList
} from "@/utils/common";

export default {
  name: "uploadIossModal",
  mixins: [Mixin],
  props: {
    receivingAddress: {
      type: Object,
      default: () => {
      }
    }
  },
  data() {
    let v = this;
    return {
      uploadIossModal: false,
      uploadIossForm: {
        iossType: 1,
        ymsIossId: null,
        iossNo: null,
      },
      ruleValidate: {
        ymsIossId: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005439'), trigger: 'change'},
        ],
        iossNo: [
          {required: true, validator: v.validateIoss(), trigger: 'blur'}
        ],
      },
      iossList: [],
      ymsPlatformOrderId: null,
      iossLogisticCost: null,
      shippingMethodName: '',
      iossLogisticCostTalg: false,
      uploadIossTitle: '',
      uploadIossType: null,
      details: {},
      enumData: []
    }
  },
  computed: {
    // 获取当前登录用户的信息
    userInfo() {
      if (this.$store.state.erpConfig) {
        return this.$store.state.erpConfig.userInfo;
      } else {
        return '';
      }
    },
    iossTypeList() {
      const ENUM_KEY = 'YmsPlatformOrderPackageRelatedIossTypeDistributorEnum';
      return getEnumList(this.enumData, ENUM_KEY, 'number')
    }
  },
  methods: {
    // 初始化数据
    async initUploadIossData(data, type, ymsPlatformOrderId) {
      let titleObj = {
        ymsOrder: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005994'),
        platformOrder: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005998')
      }
      let enumKeyList = ['YmsPlatformOrderPackageRelatedIossTypeDistributorEnum'];
      this.enumData = await getDataSetBatchList(enumKeyList);
      if (type === 'ymsOrder') {
        this.ymsPlatformOrderId = ymsPlatformOrderId;
        this.details = data;
      } else {
        this.details = data;
        this.ymsPlatformOrderId = data.ymsPlatformOrderId;
      }
      this.uploadIossTitle = titleObj[type];
      this.uploadIossType = type;
      let shippingMethodName = '';
      let ymsPlatformOrderShippings = data.ymsPlatformOrderShippings || [];
      if (ymsPlatformOrderShippings.length > 0) {
        let obj = ymsPlatformOrderShippings[0];
        // YMS物流
        if (obj.ymsLogisServiceId) {
          getYunLogisticsAll().then((yunShipList) => {
            if (yunShipList.length > 0) {
              yunShipList.map((item) => {
                if (item.ymsLogisServiceId === obj.ymsLogisServiceId) {
                  shippingMethodName = item.name;
                  this.shippingMethodName = shippingMethodName;
                }
              });
            }
          });
        }
        // 基础物流
        else {
          if (obj.shippingMethodId) {
            getQueryCarrierShippingName([obj.shippingMethodId]).then((shippingMethodList) => {
              if (shippingMethodList.length > 0) {
                shippingMethodList.map((item) => {
                  if (item.shippingMethodId === data.shippingMethodId) {
                    let carrierName = item.carrierName;
                    let carrierShippingMethodName = item.carrierShippingMethodName;
                    shippingMethodName = carrierName + (carrierShippingMethodName ? ' > ' + carrierShippingMethodName : '');
                    this.shippingMethodName = shippingMethodName;
                  }
                });
              } else {
                this.axios.get(api.get_ymsCarrierShippingMethod + obj.shippingMethodId).then(response => {
                  if (response.data.code === 0) {
                    let data = response.data.datas;
                    let carrierName = '';
                    let carrierShippingMethodName = '';
                    if (data) {
                      if (isJSON(data.carrier.carrierName)) {
                        let obj = JSON.parse(data.carrier.carrierName);
                        carrierName = obj[this.languagesVal];
                      } else {
                        carrierName = data.carrier.carrierName[this.languagesVal];
                      }
                      if (isJSON(data.carrierShippingMethod.carrierShippingMethodName)) {
                        let obj = JSON.parse(data.carrierShippingMethod.carrierShippingMethodName);
                        carrierShippingMethodName = obj[this.languagesVal];
                      } else {
                        carrierShippingMethodName = data.carrierShippingMethod.carrierShippingMethodName[this.languagesVal];
                      }
                      shippingMethodName = carrierName + (carrierShippingMethodName ? ' > ' + carrierShippingMethodName : '');
                      this.shippingMethodName = shippingMethodName;
                    }
                  }
                })
              }
            });
          }
        }
      }
      this.uploadIossModal = true;
    },
    // 确认
    uploadIossBtn() {
      let v = this;
      let query = {
        iossLogisticCost: v.uploadIossForm.iossType === 2 ? v.iossLogisticCost : null,
        iossNo: v.uploadIossForm.iossType === 1 ? v.uploadIossForm.ymsIossId : v.uploadIossForm.iossType === 3 ? v.uploadIossForm.iossNo : null,
        iossType: v.uploadIossForm.iossType,
        ymsPlatformOrderId: v.ymsPlatformOrderId
      };
      v.$refs['uploadIossForm'].validate((valid) => {
        if (valid) {
          if (v.uploadIossType === 'platformOrder') {
            v.axios.post(api.post_ymsPlatformOrder_confirmIoss, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
              if (response.data.code === 0) {
                v.uploadIossModal = false;
                v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000155'));
                v.$emit('updateData', true);
              }
            });
          } else {
            query.ymsWarehouseId = v.details.ymsWarehouseId;
            v.uploadIossModal = false;
            v.$emit('updateIossData', query);
          }
        }
      });
    },
    // 获取启用的IOSS
    openIossChange(val) {
      let v = this;
      if (val) {
        v.iossList = [];
        v.axios.get(api.get_ymsIoss_queryEnable).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas || [];
            if (data.length > 0) {
              data.map((item) => {
                item.title = item.code + '<br/>' + item.name;
                item.iossName = item.code + ' / ' + item.name;
              })
            }
            v.iossList = data;
          }
        });
      }
    },
    // 前往配置
    goIossConfig() {
      let v = this;
      localStorage.setItem('openIossConfig', JSON.stringify(true));
      setTimeout(() => {
        if (v.system === 'shopping') {
          pageJump('/distributor.html#/iossManageList', '/yms-distributor-service', '_blank');
        } else {
          const {href} = v.$router.resolve({
            path: '/iossManageList'
          });
          window.open(href, '_blank');
        }
      }, 400);
    },
    // 监听弹窗
    uploadIossChange(val) {
      if (!val) {
        this.ymsPlatformOrderId = null;
        this.shippingMethodName = '';
        this.iossLogisticCost = null;
        this.iossLogisticCostTalg = false;
        this.$refs['uploadIossForm'].resetFields();
      }
    },
    // 切换类型
    selectChange(value) {
      let v = this;
      v.$refs['uploadIossForm'].resetFields();
      v.uploadIossForm.iossType = value;
      v.iossLogisticCost = 0;
      v.iossLogisticCostTalg = false;
      setTimeout(() => {
        if (value === 2) {
          console.log('++++++details++++++', this.details)
          // 手工单
          if (v.uploadIossType === 'ymsOrder') {
            let ymsPackageGoods = v.details.goodList.map((item) => {
              return {
                quantity: item.quantity,
                ymsSku: item.ymsSku
              }
            });
            let query = {
              merchantId: v.userInfo.merchantId,
              ymsPackageInfos: [
                {
                  buyerAddress1: v.receivingAddress.streetAddress,
                  buyerCity: v.receivingAddress.city,
                  buyerCountryCode: v.receivingAddress.countryCode,
                  buyerEmail: v.receivingAddress.email,
                  buyerMobile: v.receivingAddress.mobile,
                  buyerName: v.receivingAddress.name,
                  buyerAccountId: v.receivingAddress.name,
                  buyerPhone: v.receivingAddress.phone,
                  buyerPostalCode: v.receivingAddress.postalCode,
                  buyerState: v.receivingAddress.state,
                  ymsLogisServiceId: v.details.deliveryMethodDetails.ymsLogisServiceId,
                  ymsPackageGoods: ymsPackageGoods,
                  ymsWarehouseId: v.details.ymsWarehouseId,
                }
              ]
            };
            v.axios.post(api.post_ymsPlatformOrder_getIossCostToOrder, query, {loading: true}).then(response => {
              if (response.data.code === 0) {
                let data = response.data.datas || 0;
                v.shippingMethodName = v.details.deliveryMethodDetails.name;
                if (data) {
                  v.iossLogisticCost = amountHandel(data);
                }
                v.iossLogisticCostTalg = true;
              }
            });
          }
          // 平台订单--yms订单
          else {
            let query = {
              ymsPlatformOrderId: v.ymsPlatformOrderId,
              ymsLogisServiceId: v.details.ymsPackageInfo?.ymsLogisServiceId
            }
            v.axios.post(api.post_ymsPlatformOrder_getIOSSLogisticCost, query, {loading: true}).then(response => {
              if (response.data.code === 0) {
                let data = response.data.datas || 0;
                if (data) {
                  v.iossLogisticCost = amountHandel(data);
                }
                v.iossLogisticCostTalg = true;
              }
            });
          }
        }
      }, 400);
    },
    // 校验IOSS编号
    validateIoss() {
      let v = this;
      let isIoss = v.$regular.isIoss;
      return function (rule, value, callback) {
        if (!value) {
          callback(new Error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005518')));
        } else if (!isIoss.test(value)) {
          callback(new Error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005519')));
        }
        callback();
      };
    }
  }
}
</script>

<style lang="less" scoped>

</style>